import English from "client/i18n/localization/en.json";
import Urdu from "client/i18n/localization/ur.json";

const localizations = { "en-US": English, ur: Urdu };

export default localizations;
